import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Events, PopoverController, ToastController } from 'ionic-angular';
import { EbsWebService } from '../../services/ebsWebService';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsComponentService } from "../../services/ebsComponentService";
/**
 * Generated class for the PagesEmailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'email',
  templateUrl: 'email.html',
})
export class EmailPage {

  segment: any;

  receiver: string;
  subject: string;
  body: string;
  data: any;

  customRedirectElement: any;
  customRedirectNavparams: any;
  customRedirectNavCtrl: any;

  file: string;
  filetype: string;
  fileNameEmail: string;
  audio: string;
  video: string;
  fileAttachementCustom: string;

  fileAttachementOptional: string;

  files: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private _ebsWebService: EbsWebService,
    public events: Events,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals,
    public popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    public _ebsComponentService: EbsComponentService) {



    this.events.subscribe('email:filepicker', (base64, filename, filetype) => {
      this.file = base64;
      this.filetype = filetype;
      this.fileNameEmail = filename;
      console.log('received file');
    });
    this.events.subscribe('audiocaptured', (base64) => {
      console.log('got audio yeehaw')
      this.audio = base64;
    });
    this.events.subscribe('videocaptured', (base64) => {
      console.log('got video haawyee');
      this.video = base64;
    })

    console.log(_ebsWebServiceGlobals.getEbsWebServiceEntryURL());
  }

  ionViewDidLoad() {
    this.receiver = this.navParams.get('receiver');
    this.subject = this.navParams.get('subject');
    this.body = this.navParams.get('body');
    this.data = this.navParams.get('data');
    this.fileAttachementCustom = this.navParams.get('fileAttachementCustom');
    this.customRedirectElement = this.navParams.get('customRedirectElement');
    this.customRedirectNavparams = this.navParams.get('customRedirectNavparams');
    this.customRedirectNavCtrl = this.navParams.get('customRedirectNavCtrl');
    this.fileAttachementOptional = this.navParams.get('fileAttachementOptional') || '';

    console.log(this.receiver);
    console.log(this.subject);
    console.log('data', this.data);

    this.files = [];
    let filesSplit = this.fileAttachementOptional.split(';');
    for (let i = 0; i < filesSplit.length; i++) {
      let filesSplitSplit = filesSplit[i].split('\\');
      this.files.push({ 'value': filesSplit[i], 'text': filesSplitSplit[filesSplitSplit.length - 1], 'checked': false });
    }
  }


  dismissEmailModal() {
    //let data = { 'foo': 'bar' };
    this.viewCtrl.dismiss();
  }


  sendEmail() {
    if (typeof this.data.Action == "undefined" || this.data.Action == null) {
      return;
    }

    let params = JSON.parse(this.data.DisplayText.replace(/\\/g, "\\\\")).Action;
    let base64Audio;
    let base64Video;
    let base64File;
    if (this.audio != undefined) {
      base64Audio = encodeURIComponent(this.audio.split(',')[1]);
    }
    if (this.video != undefined) {
      base64Video = encodeURIComponent(this.video.split(',')[1]);
    }
    if (this.file != undefined) {
      base64File = encodeURIComponent(this.file.split(',')[1]);
    }

    params = params.substring(params.indexOf("?") + 1) // remove /SendEmailAsJSON?
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
    postPayloadObject = postPayloadObject.replace("TO_EMAIL", this.receiver || "");
    postPayloadObject = postPayloadObject.replace("CC_EMAIL", "");
    postPayloadObject = postPayloadObject.replace("BCC_EMAIL", "");
    postPayloadObject = postPayloadObject.replace("SUBJECT_EMAIL", this.subject || "");
    postPayloadObject = postPayloadObject.replace("AUDIOFILEBASE64_FILEBYTES", base64Audio || "");
    postPayloadObject = postPayloadObject.replace("FILETYPE1_FILEBYTES", this.filetype != null ? this.filetype.split("/")[1] : "");
    postPayloadObject = postPayloadObject.replace("FILEBASE64_1_FILEBYTES", base64File || "");
    postPayloadObject = postPayloadObject.replace("FILETYPE2_FILEBYTES", 'webm');
    postPayloadObject = postPayloadObject.replace("FILEBASE64_2_FILEBYTES", base64Video || "");
    postPayloadObject = postPayloadObject.replace("FILETYPE3_FILEBYTES", "");
    postPayloadObject = postPayloadObject.replace("BODY_EMAIL", this.body || "");
    postPayloadObject = postPayloadObject.replace("FILEBASE64_3_FILEBYTES", this.getFileAttachements() || "");
    this._ebsWebService.postData(this._ebsWebServiceGlobals.getBaseURL() + this.data.Action.substring(1), postPayloadObject).toPromise().then(result => {
      console.log('yes', result);
      let toast = this.toastCtrl.create({
        message: result == null ? "Es gab einen Fehler beim senden der Email!" : result.Caption || "Es gab einen Fehler beim senden der Email!",
        duration: 5000,
        position: 'bottom'
      });
      toast.present();
      if (result != null) {
        this.viewCtrl.dismiss();
        console.log(this.customRedirectElement);
        if (this.customRedirectElement != undefined && this.customRedirectNavparams != undefined && this.customRedirectNavCtrl != undefined) {
          this._ebsComponentService.navigationController(this.customRedirectElement, this.customRedirectNavparams, this.customRedirectNavCtrl);
        }
      }
    });
  }

  getFileAttachements() {
    let attachements = '';
    let optionalFiles = this.files.filter(file => file.checked == true).map(file => file.value).join(";"); // all "checked" file objects to array to string array to string...  ¯\_(ツ)_/¯
    attachements = this.fileAttachementCustom + ';' +  optionalFiles;
    return attachements;
  }

}



// WEBPACK FOOTER //
// ./src/pages/email/email.ts